// imports
import React from 'react';
import { Link } from 'react-router-dom';
import { ICON } from '../../../assets';
import { LINKS } from '../../../constants';
import PrimaryButton from '../../button/primary';
import ConnectButton from '../../button/connect';

// interfaces / types / consts
interface AccountProps {
  disabled?: boolean;
  profileLink?: string;
}

// exports
export default function AccountDropdown(props: AccountProps): JSX.Element {
  const { profileLink, disabled } = props;
  // render
  return (
    <div className="account-dropdown-outer">
      <div className="dropdown account">
        <PrimaryButton
          text="Account"
          disabled={disabled}
          toggleElem="dropdown"
          leftIcon={ICON.PROFILE}
          className="account-dropdown"
          rightIcon={ICON.DROPDOWN_ARROW}
        />
        <ul className="dropdown-body dropdown-menu dropdown-menu-end">
          <li className="connect-btn-li"><ConnectButton outlined /></li>
          {profileLink && <li><Link to={profileLink} className="dropdown-item">Profile</Link></li>}
          <li><a className="dropdown-item" href={LINKS.GIT_BOOK} target="_blank" rel="noreferrer">Help</a></li>
          <li>
            <div className="dropdown-item dropdown-footer">
              <a
                target="_blank"
                rel="noreferrer"
                href={LINKS.OPEN_SEA_COLLECTION_IMMORTALS}
              >
                <img className="icon" src={ICON.OPEN_SEA} alt="opensea" />

              </a>
              <a target="_blank" rel="noreferrer" href={LINKS.SKYBORNE}><img className="icon" src={ICON.SKYBORNE} alt="skyborne" /></a>
              <a target="_blank" rel="noreferrer" href={LINKS.DISCORD}><img className="icon" src={ICON.DISCORD} alt="discord" /></a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}

// default props
AccountDropdown.defaultProps = { profileLink: '', disabled: false };
